import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import UIComponents from './UI.Components';
// import DidManager from '../DiDManager';
import { history } from 'kts-platform-frame/routes';
import { PageHeaderTop, PageHeaderFoot } from 'kts-xui';
import { Icon } from 'antd';
const css = require('./index.scss');
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UserManage extends ModulesBasic<IProps, any> {

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
        ModulesAction.departmentQuery();
    }
    render() {
        const { activeKey } = this.state;
        return (
            <ModulesRoot action={ModulesAction}>
                <div className={css.modules}>
                    <PageHeaderTop
                        activeKey={activeKey}
                        title="用户管理"
                        help="用户管理"
                        onChange={ModulesAction.tabsOnChange}
                        // defaultActiveKey={this.state.activeKey}
                        tabs={[
                            {
                                tab: <div style={{ paddingLeft: 20 }}>
                                    <Icon type="gongsi1" />
                                    <span>用户管理</span>
                                </div>, tabKey: '1'
                            },
                            // {
                            //     tab: <div >
                            //         <Icon type="gongsi1" />
                            //         <span>DID管理</span>
                            //     </div>, tabKey: '2'
                            // },
                        ]}

                    >
                        {/* <TabPane
                            key="usermanage"
                            tab={(
                                <div style={{ paddingLeft: 20 }}>
                                    <Icon type="gongsi1" />
                                    <span>用户管理</span>
                                </div>
                            )}
                        >
                            <UIComponents />
                        </TabPane> */}
                    </PageHeaderTop>
                    {
                        activeKey === '1' && <div>
                            <UIComponents />
                        </div>
                    }
                    {/* {
                        activeKey === '2' && <div>
                        <DidManager />
                    </div>
                    } */}
                </div>
            </ModulesRoot>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/UserManage/index.tsx